import type { PropertyInterface } from './Context/PropertyInterface'

export class Context {
  properties: PropertyInterface[]

  constructor(properties: PropertyInterface[]) {
    this.properties = properties
  }

  stringify(): string {
    return this.properties
      .map((property) => `${property.getKey()}=${property.getValue()}`)
      .join(',')
  }

  asObject(): Record<string, string | boolean | number> {
    const result: Record<string, string | boolean | number> = {}

    this.properties.forEach((property) => {
      result[property.getKey()] = property.getValue()
    })

    return result
  }
}
